import { useMemo } from 'react';
import { TabItem } from '../../components/components.interfaces';
import InventoryView from './subviews/inventory/inventory.view';
import RoutesAndScheduleView from './subviews/routesAndSchedule/routesAndSchedule.view';
import HealthAndSafetyView from './subviews/healthAndSafety/healthAndSafety.view';
import { InventoryProvider } from './contexts/inventory.context';
import { HealthAndSafetyProvider } from './contexts/healthAndSafety.context';
import { TTranslateTextType } from 'src/hooks/useTranslationHook';
import { useRbacState } from 'src/context/rbac.context';
import { hasReadPermission } from 'src/utils/rbacHelpers';

export const administrationSubRouteIds = [
  'transport',
  'inventory',
  'health-and-safety',
];

export const useAdministrationTabMenuItems = (
  translateText: TTranslateTextType
): TabItem[] => {
  const { rbac } = useRbacState();

  return useMemo(() => {
    const tabs: TabItem[] = [];

    if (hasReadPermission(rbac, 'administration', 'transport')) {
      tabs.push({
        label: translateText('administration.tabs.routesAndSchedule'),
        onClickHandler: () => {},
        tabPanel: <RoutesAndScheduleView />,
      });
    }

    if (hasReadPermission(rbac, 'administration', 'inventory')) {
      tabs.push({
        label: translateText('administration.tabs.inventory'),
        onClickHandler: () => {},
        tabPanel: (
          <InventoryProvider>
            <InventoryView />
          </InventoryProvider>
        ),
      });
    }

    if (hasReadPermission(rbac, 'administration', 'healthAndSafety')) {
      tabs.push({
        label: translateText('administration.tabs.healthAndSafety'),
        onClickHandler: () => {},
        tabPanel: (
          <HealthAndSafetyProvider>
            <HealthAndSafetyView />
          </HealthAndSafetyProvider>
        ),
      });
    }

    return tabs;
  }, [rbac, translateText]);
};

/** Returns route IDs for tabs the user has read permission for, in display order */
export const useAdministrationAvailableRouteIds = (): string[] => {
  const { rbac } = useRbacState();
  return useMemo(() => {
    const routes: string[] = [];
    if (hasReadPermission(rbac, 'administration', 'transport'))
      routes.push('transport');
    if (hasReadPermission(rbac, 'administration', 'inventory'))
      routes.push('inventory');
    if (hasReadPermission(rbac, 'administration', 'healthAndSafety'))
      routes.push('health-and-safety');
    return routes;
  }, [rbac]);
};

export const getAdministrationTabIndex = (pathname: string) => {
  const administrationTabsIndexObject = {
    transport: 0,
    inventory: 1,
    'health-and-safety': 2,
  };

  const tabIndex =
    administrationTabsIndexObject[
      pathname as keyof typeof administrationTabsIndexObject
    ];
  return tabIndex;
};

export const getAdministrationSubRouteId = (index: number) =>
  administrationSubRouteIds[index];
